import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Благодарим ви за оценката!',
  text: 'Има ли нещо, което можем да подобрим? Споделете мнението си с нас.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Вашето мнение...'
      }
    ],
    submit: {
      label: 'Изпрати'
    }
  }
};
